import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import { Group } from '@models';
import { UserBeanService, UserService } from '@services';
import { AppState } from '@store';

export const groupsResolver: ResolveFn<Nullable<Group>> = async () => {
  const userBeanService = inject(UserBeanService);
  const userService = inject(UserService);
  const router = inject(Router);
  const store: Store<AppState> = inject(Store);

  const userBean = await userBeanService.getUserBean();
  const isLoggedIn = await firstValueFrom(
    store.select((state) => state.auth.isLoggedIn)
  );

  if (isLoggedIn) {
    if (userBean.rootGroupsPermission > 3) {
      return firstValueFrom(userService.getGroup(userBean.rootGroupsId));
    }

    return new RedirectCommand(router.parseUrl('/home'));
  }

  return null;
};
